"use strict";

var sm = sm || {};
jQuery.noConflict();

(function ($) {
  'use strict'; // Generate a GUID

  sm.guid = function () {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  };

  sm.isEmptyObject = function (object) {
    return JSON.stringify(object) === '{}';
  }; // Javascript method equivalent to utils.php one


  sm.unserializeSIAP = function (str, keyValSeparator, itemSeparator) {
    keyValSeparator = keyValSeparator || '=';
    itemSeparator = itemSeparator || ';';
    str = str || '';
    if (!str.length || str.indexOf(itemSeparator) < 0) return {};
    return str.split(itemSeparator).reduce(function (memo, item) {
      if (item.length && item.indexOf(keyValSeparator) > -1) {
        var keyValue = item.split(keyValSeparator);
        memo[keyValue[0]] = keyValue[1].length ? keyValue[1] : '';
        return memo;
      }
    }, {});
  }; // Javascript method equivalent to utils.php one


  sm.serializeSIAP = function (input, keyValSeparator, itemSeparator) {
    keyValSeparator = keyValSeparator || '=';
    itemSeparator = itemSeparator || ';';
    if (!input || !(input instanceof Object)) return '';
    var output = [];

    for (var key in input) {
      output.push("".concat(key).concat(keyValSeparator).concat(input[key]));
    }

    return output.join(itemSeparator);
  };

  sm.range = function (start, end, step) {
    if (!end) {
      end = start;
      start = 0;
    }

    if (!step && step !== 0) {
      step = end - start > 0 ? 1 : -1;
    }

    var size = Math.abs(end - start) / (step ? Math.abs(step) : 1);
    return Array.from({
      length: size
    }, function (value, index) {
      return start + index * step;
    });
  };

  sm.isElementInView = function (element, fullyInView) {
    var pageTop = $(window).scrollTop();
    var pageBottom = pageTop + $(window).height();
    var elementTop = $(element).offset().top;
    var elementBottom = elementTop + $(element).height();

    if (fullyInView === true) {
      return pageTop < elementTop && pageBottom > elementBottom;
    } else {
      return elementTop <= pageBottom && elementBottom >= pageTop;
    }
  };
})(jQuery);